<template>
    <div class="mx_content">
        <div class="mx_title">
            <div class="title_left">
                <span style="color:#333333;font-weight: bold;">作业人员</span>
            </div>
            <div class="title_right">
                <el-button v-if="canEdit" size="mini" @click="addPerson">选择</el-button>
            </div>
        </div>
        <el-table v-if="updated" :data="listData" style="width: 100%" class="border"
            @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="name" align="center" width="150">
                <template #header>
                    <span class="required">*</span>
                    <span>姓名</span>
                </template>
                <template slot-scope="scope">
                    <!-- <div v-if="canEdit">
                        <el-input v-model="scope.row.name" v-can-edit :can-edit="canEdit" name="name"
                            placeholder="请输入" />
                    </div>
                    <div v-else>{{ scope.row.name }}</div> -->
                    <div>{{ scope.row.name }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="cybl" align="center">
                <template #header>
                    <span class="required">*</span>
                    <span>参与比例</span>
                </template>
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <el-input v-model="scope.row.cybl" v-can-edit :can-edit="canEdit" name="account"
                            placeholder="请输入" /> -->
                        <el-input v-model="scope.row.cybl" v-can-edit :can-edit="canEdit" name="cybl" placeholder="请输入"
                            @change="cyblChange(scope.row)">
                            <template #suffix>
                                %
                            </template>
                        </el-input>
                    </div>
                    <div v-else>{{ scope.row.cybl }}%</div>
                </template>
            </el-table-column>
            <el-table-column prop="tcje" align="center">
                <template #header>
                    <span class="required">*</span>
                    <span>提成金额</span>
                </template>
                <template slot-scope="scope">
                    <!-- <div v-if="canEdit">
                        <el-input v-model="scope.row.tcje" v-can-edit :can-edit="canEdit" name="tcje" placeholder="请输入">
                        </el-input>
                    </div>
                    <div v-else>{{ scope.row.tcje }}</div> -->
                    <div>{{ scope.row.tcje }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="qtfy" align="center">
                <template #header>
                    <!-- <span class="required">*</span> -->
                    <span>其他费用</span>
                </template>
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <el-input v-model="scope.row.qtfy" v-can-edit :can-edit="canEdit" name="qtfy" placeholder="请输入">
                        </el-input>
                    </div>
                    <div v-else>{{ scope.row.qtfy }}</div>
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row, scope.$index)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const { uuid } = require('@/global/utils/index.js')
import moment from 'moment'
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }

        // 自定义属性
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        const feeDescRules = {
            required: true
        }
        const occureDateRules = {
            required: true
        }

        const feeAmountRules = {
            required: true
        }

        const handleFeeAmountInput = (value) => {
            // 这里可以添加对费用金额的其他校验逻辑
        }

        // 如果需要，可以在这里添加对ValidationProvider实例的引用逻辑
        // 例如：
        // const { validate } = useValidation();
        // ...

        return {
            feeTypeRules,
            feeAmountRules,
            handleFeeAmountInput,
            feeDescRules,
            occureDateRules
            // ... 其他响应式引用
        }
    },
    data() {
        return {
            // 通用变量
            index: '',
            moduleInfo: {},
            loginUser: this.$store.getters.loginUser,
            listData: [],
            // 自定义变量
            countAll: '0.00',
            updated: true,
            uploadId: '' // 当前上传行id
        }
    },
    computed: {},
    watch: {
        listData: {
            handler(newVal, oldVal) {
                // 当listData发生变化时，更新vo.passenger[listName]
                // this.vo.passenger[this.listName] = newVal
                this.vo.dynamicFields.persons = newVal
            },
            deep: true
        }
    },
    created() { },
    beforeDestroy() { },
    mounted() {
        // this.moduleInfo = {
        //     delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
        //     addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
        //     insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
        //     moduleCode: this.module,
        //     updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
        //     listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
        //     getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
        //     querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        // }
        // this.getListData()
        if (!this.vo.dynamicFields.persons) {
            this.vo.dynamicFields.persons = []
        }
        this.listData = this.vo.dynamicFields.persons
    },
    updated() { },
    methods: {
        cyblChange(row) {
            if (row.cybl) {
                row.tcje = (this.vo.dynamicFields.jine * (row.cybl / 100)).toFixed(2) || 0
            }
        },
        cyblChange2() {
            if (this.listData.length > 0) {
                this.listData.forEach(item => {
                    this.cyblChange(item)
                })
            }
        },
        dialogClick(index) {
            this.index = index
        },
        onSelectListpageRowCompleted: function (val, arr) {
            this.listData[this.index].projectName = val[0].flSubject
        },
        fileTypeFormat(value) {
            console.log(value, 'value')
            if (value == 1) {
                return '工程造价咨询合同'
            } else if (value == 2) {
                return '报送资料(施工合同、施工图纸、签证、变更单等)'
            } else if (value == 3) {
                return '工程量计算底稿'
            } else if (value == 4) {
                return '成果文件(工程概况、工作方案或实施方案、质量控制流程表、审核日记、会议纪要、工程资料移交清单、成果文件签收单、工程造价咨询业务质量回访单、盖章版的成果文件扫描件、计价软件版、PDF版、Excel版、xml版'
            }
        },
        uploadChange(row) {
            this.uploadId = row.id
        },
        truncateFileName(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach([files])

                console.log(files, fileList)
            }
        },
        uploadAttach(fileList) {
            const uploadId = this.uploadId
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', 'ATTACH')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)

                // this.updated = false
                // this.listData.forEach(i => {
                //     if (i.id === this.uploadId) {
                //         // 如果attachments数组还不存在，则创建它
                //         if (!i.passenger.attachments) {
                //             this.$set(i.passenger, 'attachments', [{}])
                //         }

                //         // 设置或更新attachments数组的第一个元素
                //         this.$set(i.passenger.attachments[0], 'fileName', item.name)
                //     }
                // })
                // this.updated = true // 标记已更新
                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/upload',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.listData.forEach((i) => {
                            if (i.id === uploadId) {
                                // 如果attachments数组还不存在，则创建它
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments', [{}])
                                }
                                i.invoiceId = res.body.invoiceId
                                i.passenger.attachments = [...res.body.uploadAttachList]
                                i.fileSize = res.body.uploadAttachList[0].fileSize
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })

            console.log(this.listData, 'this.listData')
        },
        handleRemove(file, row) {
            this.$http({
                method: 'delete',
                url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                params: {
                    attachIds: file.id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.updated = false
                    this.$message.success(res.message)
                    this.listData.forEach((i) => {
                        if (i.id === row.id) {
                            i.passenger.attachments = []
                        }
                    })
                    console.log(this.listData, 'this.listData')
                    this.$nextTick(() => {
                        this.updated = true
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/' + this.baseUrl + '/' + this.module + '/downloadById?inline=true&attachIds=' + attach.id)
        },
        getCountAll() {
            let count = 0
            this.listData.forEach((item) => {
                if (item.feeAmount) {
                    count += Number(item.feeAmount)
                }
            })

            this.countAll = count
            this.vo.expenseAmount = this.countAll
            this.vo.payAmount = this.countAll
        },
        async getListData(model) {
            if (this.isHttp) {
                const data = [{ compare: '=', field: 'formId', merge: false, value: this.vo.id }]
                const res = await this.$app.querydata(this.moduleInfo.querydata, data)
                console.log(res)
                if (res.code === 'success') {
                    this.listData = res.body.listdata
                }
            } else if (this.listName) {
                if (this.vo.passenger && this.vo.passenger[this.listName] && this.vo.passenger[this.listName].length > 0) {
                    this.vo.passenger[this.listName].forEach((item) => {
                        if (!item.formId) {
                            item.formId = this.vo.id
                        }
                        if (!item.id) {
                            item.id = uuid()
                        }
                        if (!item.occureDate && item.occurDate) {
                            item.occureDate = item.occurDate
                        }
                        if (!item.creatorId) {
                            item.creatorId = this.loginUser.id
                        }
                        if (!item.createTime) {
                            // 获取当前时间
                            const now = moment()
                            // 格式化当前时间
                            const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
                            item.createTime = formattedNow
                        }
                    })
                    this.listData = this.vo.passenger[this.listName]
                    this.getCountAll()
                }
            } else {
                console.log('请传递listName参数或改用接口获取数据')
            }
        },
        // 监听input，处理数字
        validateInput(value, scope) {
            console.log(value, scope, 'value')
            value = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
            value = value.replace(/^\./, '') // 去掉开头的小数点
            value = value.replace(/\.{2,}/g, '.') // 去掉多余的小数点
            value = value.replace(/^0+(\d)/, '$1') // 去掉开头的多余零
            value = value.replace(/^(\d+\.\d\d)\d+$/, '$1') // 限制只能输入两位小数
            this.$set(this.listData[scope.$index], scope.column.property, value)
            this.getCountAll()
            console.log(this.listData, 'listData')
        },
        // 删除当前行
        delClick(row, index) {
            this.listData.splice(index, 1)
        },
        addPerson() {
            console.log('addPerson2', this)
            // selectStaff(row, index, dialogTitle) {
            let index = 0
            let dialogTitle = '选择人员'
            const el = {
                dialogTitle,
                index,
                attrs: { 'dialog-title': dialogTitle, 'org-self': 'true', vo: this.vo, multiple: true },
                value: ''
            }
            const vnode = {
                context: this,
                data: {
                    model: { expression: 'selectDialog' },
                    attrs: {}
                }
            }
            this.$bus.emit('openSelectDialog', el, { value: 'staff' }, vnode)
        },
        onSelectStaffCompleted(val, attr) {
            console.log(val, attr, this.listData)
            val.forEach((item) => {
                this.listData.push({
                    name: item.name,
                    cybl: '',
                    tcje: '',
                    qtfy: ''
                })
            })
        },
        addMx() {
            // this.$http({
            //     url: this.moduleInfo.addNewUrl,
            //     method: 'post'
            // }).then((res) => {
            //     console.log(res, 'res')
            //     if (res.code === 'success') {
            //         res.body.vo.formId = this.vo.id
            //         res.body.vo.creatorId = this.loginUser.id

            //         // 获取当前时间
            //         const now = moment()
            //         // 格式化当前时间
            //         const formattedNow = now.format('YYYY-MM-DD HH:mm:ss')
            //         res.body.vo.createTime = formattedNow

            //         this.listData.push(res.body.vo)
            //     }
            // })
            this.listData.push({
                name: '',
                cybl: '',
                tcje: '',
                qtfy: ''
            })
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table {
    border: 1px solid transparent;
}

/deep/ .el-table .el-link--inner {
    width: 100%;
}

.mx_content /deep/ .el-table__body-wrapper tr td:last-child {
    border-right-color: #e2e7ed !important;
}

.mx_content {
    .mx_title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #999;
        justify-content: space-between;
        // background: #f2f5fb;
        padding: 0 10px;
    }
}

.attachment-link-wrapper {
    display: flex;
    align-items: center;
    /* 如果需要垂直居中 */
    justify-content: space-between;

    /* 确保链接和按钮之间有间隔，并分别位于开始和结束位置 */
    .el-lint-inner {
        width: 100%;
    }
}

.attachment-link {
    flex: 1;
    /* 占据可用空间，但不会挤压删除按钮 */
    overflow: hidden;
    /* 隐藏超出容器的部分 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    /* 其他你需要的样式 */
}

.remove-button {
    /* 确保按钮始终可见，并位于行尾 */
    /* 你可以添加更多的样式来美化按钮 */
}

.required {
    color: #ff0000;
    margin-right: 3px;
}

:deep(.el-input__suffix) {
    display: flex;
    align-items: center;
}
</style>
